import easydropdown from 'easydropdown';

(function ($) {
    $('[data-behaviour="dropdown-select"]').on('change', function () {
        var filterUrl = $(this).find('option:selected').data('href');

        if (filterUrl) {
            window.location.href = filterUrl;
        }
    });

    $('[data-behaviour="dropdown-select-seasons-stats"]').on('change', function () {
        var $currentSeasonsStats = $('.database-data__seasons-stats.active');
        var $seasonsStats = $('.database-data__seasons-stats[data-target="' + $(this).find('option:selected').data('target') + '"]');

        if ($currentSeasonsStats.length > 0) {
            $currentSeasonsStats.removeClass('active');
        }

        if ($seasonsStats.length > 0) {
            $seasonsStats.addClass('active');
        }
    });

    const $selects = $('[data-select="styled"]');
    if ($selects) {
        $selects.each(function() {
            easydropdown($(this)[0]);
        });
    }

})(jQuery);
